import { useState } from "react";
import { useEventListener, useInterval } from "usehooks-ts";
import { formatDate } from "helpers";

const useClock = (format: Intl.DateTimeFormatOptions) => {
  const [time, setTime] = useState(new Date());
  const formattedTime = formatDate(time, format);

  const update = () => {
    setTime(new Date());
  };

  useInterval(update, 60_000);
  useEventListener("focus", update);

  return formattedTime;
};

export { useClock };
